export const getIsValidatingToken = state => state.auth.isValidatingToken
export const getIsLoading = state => state.auth.currentUser.isLoading
export const getIsSignedIn = state => Boolean(state.auth.currentUser)
export const getCurrentUser = state => state.auth.currentUser
export const getAuthError = state => state.auth.signInError
export const getIsAdmin = state => {
  if (!state.auth.currentUser) return false
  return !!state.auth.currentUser.admin
}
